import { ResolverTag } from '@ps/web-core-enums';
import { StarsButton, Translation } from '@ps/web-shared-components';
import { addDays, addHours, format } from 'date-fns';
import React from 'react';

import ResolverLink from '@swf/components/ResolverLink/ResolverLink';
import { SelfExcludedBrandsList } from '@swf/notification';

import { ExclusionTime } from '../../../shared/definitions';
import styles from '../../../shared.scss';
import { ExclusionType } from '../../definitions';
import type { ExclusionResponseProps as Props } from '../../definitions';
import useLogoutUser from '../../hooks/useLogoutUser';
import DefaultBreakResponse from '../DefaultBreakResponse/DefaultBreakResponse';
import ExclusionTopMessage from '../ExclusionTopMessage/ExclusionTopMessage';

import {
  TXTCLI_For_more_informationX_please_v_ELL_1,
  TXTCLI_Logout,
  TXTWCL_Any_remaining_funds_in_your_XX_ELL_1,
  TXTWCL_This_canXt_be_undone_by_our_cu_ELL,
  TXTWCL_XbXYour_XXAccountBrandXX_Accou_ELL,
  TXTWCL_XbXYour_exclusion_period_will__ELL,
  TXTWCL_You_have_chosen_a_permanent_Se_ELL
} from './ExclusionResponseUK.messages.json';

const ExclusionResponseUK: React.FC<Props> = ({ daysRequested, exclusionType, endDate }) => {
  const logoutUser = useLogoutUser();
  const indefiniteExclusion = daysRequested === ExclusionTime.Indefinite;

  if (exclusionType === ExclusionType.Break) {
    return <DefaultBreakResponse daysRequested={daysRequested} endDate={endDate} />;
  }

  return (
    <div>
      {indefiniteExclusion ? (
        <>
          <Translation {...TXTWCL_You_have_chosen_a_permanent_Se_ELL} />
          <Translation tagName="p" {...TXTWCL_XbXYour_XXAccountBrandXX_Accou_ELL} />
        </>
      ) : (
        <>
          <ExclusionTopMessage daysExclude={Number(daysRequested)} />
          <Translation
            tagName="p"
            {...TXTWCL_XbXYour_exclusion_period_will__ELL}
            values={{
              0: format(
                daysRequested && daysRequested < 0
                  ? addHours(new Date(), Math.abs(daysRequested))
                  : addDays(new Date(), daysRequested || 0),
                'Pp'
              )
            }}
          />
        </>
      )}
      <SelfExcludedBrandsList />
      <Translation tagName="p" {...TXTWCL_This_canXt_be_undone_by_our_cu_ELL} />
      <Translation tagName="p" {...TXTWCL_Any_remaining_funds_in_your_XX_ELL_1} />
      <Translation
        tagName="p"
        {...TXTCLI_For_more_informationX_please_v_ELL_1}
        values={{
          a: (msg: React.ReactNode) => (
            <ResolverLink resolverTag={ResolverTag.HelpCenter}>{msg}</ResolverLink>
          )
        }}
      />
      <StarsButton
        block
        translation={TXTCLI_Logout}
        className={styles.logoutButton}
        onClick={logoutUser}
      />
    </div>
  );
};

export default ExclusionResponseUK;
